import React from "react";

const Modal = ({ isOpen, onClose, children, className }:any) => {
  return isOpen ? (
    <div className=" fixed inset-0 flex items-center justify-center z-30 ">
      <div
        className="absolute inset-0 bg-gray-800 opacity-50 transition-all ease-in-out"
        onClick={onClose}
      ></div>
      <div
        className={`mx-8 bg-primary transition-all ease-in-out duration-200 p-6 text-white shadow-lg rounded-lg z-50  ${className}`}
      >
        {children}
      </div>
    </div>
  ) : null;
};

export default Modal;
